import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const BMPage = (props: Props): JSX.Element => {
    return (
        <S_BMPage className={props.className}>
            <CustomMapPage
                mapId={'5cf4e6d9-1747-49fb-bd15-dfb03ab06156'}
                mapProps={{
                    pitch: 30,
                    light: {
                        anchor: 'viewport',
                        color: 'white',
                        intensity: 0.15
                    }
                }}
                automaticHeader={true}
            />
        </S_BMPage>
    );
};

const S_BMPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
